import { Link } from "react-router-dom";
import { Plane, ArrowRight } from "lucide-react";

const airports = [
  {
    code: "PUJ",
    name: "Punta Cana International",
    zones: "Bávaro · Cap Cana · Uvero Alto · Macao",
    time: "10–45 min to most resorts",
  },
  {
    code: "SDQ",
    name: "Las Américas (Santo Domingo)",
    zones: "Santo Domingo · Boca Chica · Juan Dolio",
    time: "25 min – 2h 30m",
  },
  {
    code: "LRM",
    name: "La Romana International",
    zones: "Casa de Campo · Bayahíbe · Dominicus",
    time: "15–40 min",
  },
  {
    code: "STI",
    name: "Cibao (Santiago)",
    zones: "Santiago · Jarabacoa · Puerto Plata",
    time: "20 min – 1h 30m",
  },
  {
    code: "POP",
    name: "Gregorio Luperón (Puerto Plata)",
    zones: "Playa Dorada · Sosúa · Cabarete",
    time: "15–35 min",
  },
];

const AirportHubsSection = () => (
  <section className="py-20 bg-muted/40">
    <div className="container mx-auto px-4">
      <div className="max-w-2xl mb-10">
        <p className="text-primary font-sans font-semibold tracking-[0.2em] uppercase text-xs mb-3">
          Airport coverage
        </p>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
          We pick you up at every major airport in the Dominican Republic
        </h2>
        <p className="font-sans text-muted-foreground">
          Your driver tracks your flight and waits inside the terminal with a name
          sign — no lines, no surprises, no extra fees for delays.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {airports.map((a) => (
          <article
            key={a.code}
            className="rounded-xl border border-border bg-card p-6 hover:shadow-lg transition-shadow"
          >
            <div className="flex items-center gap-3 mb-3">
              <span className="w-11 h-11 rounded-lg bg-primary/10 flex items-center justify-center">
                <Plane className="w-5 h-5 text-primary" aria-hidden="true" />
              </span>
              <div>
                <span className="font-display text-xl font-bold text-card-foreground">{a.code}</span>
                <p className="font-sans text-xs text-muted-foreground">{a.name}</p>
              </div>
            </div>
            <p className="font-sans text-sm text-card-foreground/80 mb-1">{a.zones}</p>
            <p className="font-sans text-sm text-muted-foreground mb-4">{a.time}</p>
            <Link
              to="/transfers"
              className="inline-flex items-center gap-1.5 font-sans text-sm font-semibold text-primary hover:underline"
            >
              See {a.code} transfers <ArrowRight className="w-4 h-4" aria-hidden="true" />
            </Link>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default AirportHubsSection;
